import React from 'react';
import PropTypes from 'prop-types';

function HitSpecialOffer({specialOffer}) {
    if (!specialOffer) {
        return null;
    }

    return (
        <div className="special-offer hidden-mini hidden-gallery component--translucent">
            <i aria-hidden className="icon-tag icon-white" />
            <span className="label-special-offer text-uppercase">
                {specialOffer.message}
            </span>
            <span className="content-special-offer">
                {specialOffer.title}
            </span>
            <span className="special-offer-dates">
                {specialOffer.formattedDate}
            </span>
        </div>
    );
}

HitSpecialOffer.propTypes = {
    specialOffer: PropTypes.shape({
        formattedDate: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    })
};

export default HitSpecialOffer;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitSpecialOffer/HitSpecialOffer.js